// Passwort und zweiten Faktor verwaltet man zentral in PowerID „Mein Konto“ (28.10.2026, Christian + powerid-Session) —
// PowerCare hat dafuer keinen eigenen Bereich und keine Rechte. Der Ruecksprung fuehrt auf die eigene Subdomain
// (*.powercare.cloud ist in PowerID erlaubt).
export const POWERID_KONTO = 'https://powerid.powersolutions.ch/konto';

export function meinKontoUrl(): string {
  return `${POWERID_KONTO}?zurueck=${encodeURIComponent(window.location.origin + '/')}`;
}
